/* unplugin-vue-components disabled */import { render } from "./PostFootFunction.vue?vue&type=template&id=3925e743"
import script from "./PostFootFunction.vue?vue&type=script&lang=js"
export * from "./PostFootFunction.vue?vue&type=script&lang=js"

import "./PostFootFunction.vue?vue&type=style&index=0&id=3925e743&lang=css"

import exportComponent from "/root/steemboylikegirlClub/gitproject/steemboylikegirlclub/steemboylikegirlclub/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__